import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useGoogleMaps } from "./GoogleMapsContext";
import { Alert, CloseButton } from "./App";
import DotLoader from "react-spinners/DotLoader";
import { EstiloButton } from "./App";

const FormGroupMaps = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  label {
    font-size: small;
    position: absolute;
    top: -20px;
    left: 10px;
    padding: 0 5px;
  }
  & input {
    border: none;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    border-radius: 2px;
    width: 100%;
    &:focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }
  }
`;
const CalculadoraDistancia = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
`;
const DivMaps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
`;
const DivSpin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
`;

function MapDistanceCalculator() {
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [distance, setDistance] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  // Accede al contexto de Google Maps
  const googleMaps = useGoogleMaps();

  useEffect(() => {
    if (googleMaps) {
    }
  }, [googleMaps]);

  const calculateDistance = async () => {
    if (!origin || !destination) {
      setShowAlert(true);
      return;
    }
    const google = window.google; // Importa el objeto `google`.

    const distanceService = new google.maps.DistanceMatrixService();

    distanceService.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
      },
      (response, status) => {
        if (status === "OK") {
          const result = response.rows[0].elements[0];
          if (result.status === "OK") {
            setDistance(result.distance.text);
            showDestinationMap();
          }
        } else {
          console.error("Error al calcular la distancia:", status);
        }
      }
    );
  };

  const showDestinationMap = async () => {
    const google = window.google; // Importa el objeto `google`.

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: destination }, (results, status) => {
      if (status === "OK" && results.length > 0) {
        const map = new google.maps.Map(document.getElementById("map"), {
          center: results[0].geometry.location,
          zoom: 12,
        });

        new google.maps.Marker({
          position: results[0].geometry.location,
          map,
          title: destination,
        });
      } else {
        console.error(
          "Error al obtener las coordenadas de la ciudad de destino:",
          status
        );
      }
    });
  };

  return (
    <CalculadoraDistancia>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Complete los campos de origen y destino.
        </Alert>
      )}
      <h5>Calculadora de Distancia</h5>
      <FormGroupMaps>
        <label htmlFor="origin">Origen:</label>
        <input
          type="text"
          id="origin"
          value={origin}
          onChange={(e) => setOrigin(e.target.value)}
        />
      </FormGroupMaps>
      <FormGroupMaps>
        <label htmlFor="destination">Destino:</label>
        <input
          type="text"
          id="destination"
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
        />
      </FormGroupMaps>
      <EstiloButton onClick={calculateDistance}>Calcular</EstiloButton>
      {distance && <h5>Distancia: {distance}</h5>}
      {googleMaps && (
        <DivMaps id="map">
          <DivSpin>
            <div>
              <h5>Esperando datos</h5>
            </div>
            <DotLoader color="#c20000" size={40} />
          </DivSpin>
        </DivMaps>
      )}
    </CalculadoraDistancia>
  );
}

export default MapDistanceCalculator;
